var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M131.481 20.2515C134.4 27.7771 136 35.9531 136 44.4982C136 81.7783 105.555 112 68 112C30.4446 112 0 81.7783 0 44.4982C0 35.9531 1.59985 27.7771 4.51877 20.2515H131.481Z",
    fill: "#ED213A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.539 44.4983C124.539 75.4952 99.2259 100.623 68 100.623C36.7742 100.623 11.4611 75.4952 11.4611 44.4983C11.4611 35.8144 13.4478 27.59 16.9957 20.2515H119.004C122.552 27.59 124.539 35.8144 124.539 44.4983Z",
    fill: "#ED213A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.9999 88.9969C92.7573 88.9969 112.827 69.0743 112.827 44.4985C112.827 19.9226 92.7573 0 67.9999 0C43.2426 0 23.1729 19.9226 23.1729 44.4985C23.1729 69.0743 43.2426 88.9969 67.9999 88.9969Z",
    fill: "#ED213A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77.6581C86.4489 77.6581 101.405 62.8119 101.405 44.4982C101.405 26.1846 86.4489 11.3384 68 11.3384C49.551 11.3384 34.5952 26.1846 34.5952 44.4982C34.5952 62.8119 49.551 77.6581 68 77.6581Z",
    fill: "#ED213A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0787 34.8729L81.1758 30.9985L54.8257 57.1554L58.7287 61.0298L85.0787 34.8729Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.729 30.9987L54.826 34.873L81.1761 61.0299L85.0791 57.1556L58.729 30.9987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailure);
export default __webpack_public_path__ + "static/media/payment-failure.ffcdf414518f5578ef463b1b88198c05.svg";
export { ForwardRef as ReactComponent };